import Reflux from 'reflux'
export default Reflux.createActions(['recordsCmp','currentRecordChanged',
	'dataGridUserChanged','RecordFieldChanged','RecordDataMethodFieldChanged','groupCurrentRecordChanged',
	'RecordAutoSave','RecordAutoSaveCmp','RecordsRestoreCmp','LinkGroupActive','RecordNext',
	'RecordNextPage','RecordPrev','RecordPrevPage','RecordFirst','RecordLast','RecordRefresh',
	'RecordFetchAll','RecordNew','autoSaveBefore','RenderUpdateModifiedTag','groupCurrentRecordChangedNotGridUserOp']);


// WEBPACK FOOTER //
// ./src/actions/RecordsActions.js